<template>
  <div>
    <h5 id="authModalLabel" class="modal-title">Регистрация</h5>

    <form v-if="!isRegisetred" class="my-4" @submit.prevent="register">
      <div class="mb-3">
        <label for="username" class="form-label">Имя</label>
        <input id="username" v-model="form.full_name" type="text" class="form-control" required />
      </div>
      <div class="mb-3">
        <label for="email" class="form-label">E-mail</label>
        <input id="email" v-model="form.email" type="email" class="form-control" required />
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Пароль</label>
        <input
          id="password"
          v-model="form.password"
          type="password"
          class="form-control"
          required
          @input="checkPassword"
        />
      </div>
      <div class="error" role="alert">{{ error }}</div>
      <div class="my-3 form-check">
        <input id="acceptTerms" v-model="form.acceptTerms" type="checkbox" class="form-check-input" required />
        <label class="form-check-label" for="acceptTerms" style="font-size: 15px">
          Я принимаю <a href="#">условия сервиса</a> и согласен на обработку
          <a href="#">персональных данных.</a>
        </label>
      </div>

      <button type="submit" class="btn btn-primary w-100" :disabled="!isFormValid">
        <template v-if="!isLoading">Зарегистрироваться</template>
        <div v-else class="loader mx-auto my-0"></div>
      </button>
    </form>
    <template v-else>
      <div class="registration-success">
        <h5>Вы успешно зарегистрировались</h5>
        <p>Теперь войдите под своими данными. Также проверьте указанную почту для письма об успешной регистрации.</p>
        <button type="button" class="btn btn-primary w-100" @click="switchView('AuthView')">Войти</button>
      </div>
    </template>
    <div class="divider"></div>
    <!-- </form> -->
    <template v-if="!isRegisetred">
      <p class="mt-3 mb-1">У вас уже есть аккаунт?</p>
      <button type="button" class="btn btn-link" @click="switchView('AuthView')">Войти</button>
    </template>
  </div>
</template>

<script>
  import { ref, computed } from 'vue';
  import AuthService from '../services/auth';

  export default {
    name: 'RegisterView',
    setup(props, { emit }) {
      const isLoading = ref(false);
      const username = ref('');
      const error = ref(null);
      const email = ref('');
      const password = ref('');
      const isRegisetred = ref('');
      const form = ref({
        full_name: '',
        email: '',
        password: '',
        acceptTerms: '',
      });

      const register = () => {
        isLoading.value = true;
        if (!form.value.acceptTerms) {
          isLoading.value = false;
          alert('Пожалуйста, примите условия.');
          return;
        }
        const data = {
          full_name: form.value.full_name,
          email: form.value.email,
          password: form.value.password,
        };
        AuthService.registration(data)
          .then((response) => {
            isRegisetred.value = true;
            isLoading.value = false;

            return Promise.resolve(response);
          })
          .catch((error) => {
            isLoading.value = false;
            const emailError = error?.response?.data?.email?.[0];

            if (emailError === 'Пользователь with this Электронная почта already exists.') {
              alert('Пользователь с такой почтой уже зарегистрирован');
            } else {
              alert('Не удалось завершить регистрацию. Проверьте данные и попробуйте еще раз.');
            }
            return Promise.reject(error);
          });
      };

      const switchView = (view) => {
        emit('switchView', view);
      };

      // Проверка валидности формы
      const isFormValid = computed(() => {
        return (
          form.value.full_name &&
          form.value.email &&
          form.value.password &&
          form.value.password.length >= 8 &&
          form.value.acceptTerms
        );
      });

      const checkPassword = () => {
        const minLength = /.{8,}/; // Проверка на минимальную длину (8+ символов)
        const hasDigit = /[0-9]/; // Проверка на наличие хотя бы одной цифры
        const hasSpecialChar = /[!@#$%^&*()_+<>?-]/; // Проверка на наличие специального символа

        if (!minLength.test(form.value.password)) {
          error.value = 'Пароль должен содержать минимум 8 символов.';
        } else if (!hasDigit.test(form.value.password)) {
          error.value = 'Пароль должен содержать хотя бы одну цифру.';
        } else if (!hasSpecialChar.test(form.value.password)) {
          error.value = 'Пароль должен содержать хотя бы один специальный символ.';
        } else {
          error.value = null;
        }
      };

      return {
        isRegisetred,
        form,
        username,
        email,
        password,
        isFormValid,
        error,
        isLoading,
        register,
        switchView,
        checkPassword,
      };
    },
  };
</script>
